import React from 'react';
import { Handle, Position } from 'reactflow';
import { Square } from 'lucide-react';

const EndNode = ({ data }) => {
  return (
    <div className="px-4 py-2 shadow-md rounded-lg bg-red-500 text-white border-2 border-red-600">
      <div className="flex items-center space-x-2">
        <Square className="h-4 w-4" />
        <div className="text-sm font-medium">{data.label}</div>
      </div>
      
      <Handle
        type="target"
        position={Position.Top}
        style={{
          background: '#ef4444',
          border: '2px solid #dc2626',
        }}
      />
    </div>
  );
};

export default EndNode;